import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
export function FounderStory() {
  return <Section background="sand" data-id="element-60">
      <div className="grid md:grid-cols-5 gap-12 items-center" data-id="element-61">
        <div className="md:col-span-2" data-id="element-62">
          <div className="rounded-2xl overflow-hidden shadow-lg" data-id="element-63">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nbJVafVZgRcxD2AxVMVQyD/0225681B-F332-4CF8-BE10-DDAFB26CF5D9_1_105_c.jpg" alt="Natasha Khalil, Founder of Farasha Medical Aid" className="w-full h-full object-cover" data-id="element-64" />
          </div>
        </div>
        <div className="md:col-span-3" data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-primary-deep-blue mb-4" data-id="element-66">
            Our Founder's Story
          </h2>
          <p className="text-lg font-inter text-neutral-charcoal mb-4" data-id="element-67">
            Natasha Khalil, a first-generation Egyptian-Mexican American,
            founded Farasha Medical Aid after witnessing how healthcare
            disparities affected communities in Egypt, where her father was
            raised.
          </p>
          <p className="text-lg font-inter text-neutral-charcoal mb-6" data-id="element-68">
            "Farasha"—butterfly in Arabic—honors her late grandmother, Kamilia,
            and symbolizes how small, focused interventions can create
            meaningful transformation in healthcare access for underserved
            communities.
          </p>
          <Button href="/about" variant="secondary" data-id="element-69">
            Meet Our Founder
          </Button>
        </div>
      </div>
    </Section>;
}